
/* 
Use: Common JS functions
Scope: All devices
Theme: Rexam Pension Plan
Copyright 2024, © Rexam Pension Plan
Author: Appoly
*/

require('./cookieconsent-init.js');

/*************************************************************************
#Main Function
**************************************************************************/

var appoly = [];

(function ($) {
	(function() {
		
		
		/*************************************************************************
		#Mobile Off-Canvas Navigation
		**************************************************************************/
		
		this.offCanvasNavigation = function () {
			var openMenu = $('#open-menu'),
				closeMenu = $('.close-menu'),
				withMenu = $('.off-canvas-navigation .menu-item-has-children'),
				bodyElement = $('body');
				
			if ( openMenu.length || openSearch.length ) {
				bodyElement.addClass('with-off-canvas-section');
			}
			
			if (openMenu.length) {
				openMenu.click(function(e) {
					e.preventDefault();
					
					if (!bodyElement.hasClass('show-menu')) {
						bodyElement.addClass('show-menu');
					} else {
						bodyElement.removeClass('show-menu');
					}
				});
			}
			
			if (closeMenu.length) {
				closeMenu.click(function(e) {
					e.preventDefault();
					
					bodyElement.removeClass('show-menu');
				});
			}
			
			if (withMenu.length) {
				withMenu.each(function () {
					var thisElement = $(this);
					
					thisElement.append( '<button class="sub-menu-button"><span class="screen-reader">Open sub menu</span></button>' );
		
					var withMenuButton = thisElement.find('.sub-menu-button');
		
					if (withMenuButton.length) {
						withMenuButton.click(function() {
							if (!thisElement.hasClass('menu-open')) {
								thisElement.addClass('menu-open');
							} else {
								thisElement.removeClass('menu-open');
							}
						});
					}
				});
			}
		};
		
		/*************************************************************************
		#Fixed Navigation
		**************************************************************************/
		
		this.fixedNavigation = function() {
			var fixedNavigation = $('header');
			
			if ( fixedNavigation.length ) {
				fixedNavigation.each(function () {
					var thisElement = $(this),
						lastScrollTop = 0;
					
					scrollChanges = function() {
						var latestScrollTop = $(window).scrollTop();
						
						if ( latestScrollTop > 1 ) {
							thisElement.addClass('scrolled');
						} else {
							thisElement.removeClass('scrolled');
						}
					};
					
					scrollChanges();
					
					$(window).on('scroll', function() {
						scrollChanges();
					});
				});
			}
		};
		
		/*************************************************************************
		#Content Nav
		**************************************************************************/
		
		this.contentNav = function() {
			let mainHeader = document.querySelector("header").offsetHeight;
			let mainNavLinks = document.querySelectorAll(".navigation-bar a");
			let mainSections = document.querySelectorAll(".linked-section");
			
			let lastId;
			let cur = [];
						
			window.addEventListener("scroll", event => {
				let fromTop = window.scrollY + mainHeader*1.5;
				
				mainNavLinks.forEach(link => {
					let section = document.querySelector(link.hash);
				
					if ( section.offsetTop <= fromTop && section.offsetTop + section.offsetHeight > fromTop ) {
						link.classList.add("active");
					} else {
						link.classList.remove("active");
					}
				});
			});
		};
		
		
		/*************************************************************************
		#FAQs Accordion
		**************************************************************************/
		
		this.faqsAccordion = function() {
			var faqsModule = $('.faqs-module');
		
			if ( faqsModule.length ) {
				faqsModule.each(function () {
					var thisModule = $(this),
						faq = thisModule.find('.faq'),
						showAll = thisModule.find('.show-all'),
						hideAll = thisModule.find('.hide-all');
						
					if ( showAll.length ) {
						showAll.on("click", function(e){							
							faq.each(function () {
								var thisElement = $(this),
									tab = thisElement.find('.faq-title');
									
								if (tab.length) {
									tab.each(function () {
										var thisItem = $(this);
										
										if ( !thisItem.hasClass('open') ) {
											thisItem.addClass('open');
											thisItem.next('.faq-content').addClass('open');
										} 
									});
								}
							});
						});
					}
						
					if ( hideAll.length ) {
						hideAll.on("click", function(e){							
							faq.each(function () {
								var thisElement = $(this),
									tab = thisElement.find('.faq-title');
									
								if (tab.length) {
									tab.each(function () {
										var thisItem = $(this);
										
										thisItem.removeClass('open');
										thisItem.next('.faq-content').removeClass('open');
									});
								}
							});
						});
					}
						
					if ( faq.length ) {
						faq.each(function () {
							var thisElement = $(this),
								tab = thisElement.find('.faq-title');
								
							if (tab.length) {
								tab.each(function () {
									var thisElement = $(this);
							
									thisElement.on("click", function(e){
										e.preventDefault();
										var thisItem = $(this);
										thisItem.toggleClass('open');
										thisItem.next('.faq-content').toggleClass('open');
									});
								});
							}
						});
					}
				});
			}
		};
		
		/*************************************************************************
		#Open Consultation Form
		**************************************************************************/
		
		this.OpenContactLightbox = function () {
			var contactLightbox = $('.contact-lightbox'),
				showLightbox = $('.show-lightbox');
			
			if ( contactLightbox.length && showLightbox.length ) {
				showLightbox.each(function () {
					var thisElement = $(this);
		
					thisElement.click(function() {
						if (!$('body').hasClass('show-lightbox')) {
							$('body').addClass('show-lightbox');
						} else {
							$('body').removeClass('show-lightbox');
						}
					});
				});
				
				contactLightbox.each(function () {
					var thisElement = $(this),
						closeLightbox = $('.close-lightbox');
		
					if ( closeLightbox.length ) {
						closeLightbox.click(function() {
							if ($('body').hasClass('show-lightbox')) {
								$('body').removeClass('show-lightbox');
							}
						});
					}
				});
			}
		};
		
	}).apply(appoly);
}(jQuery));


/*************************************************************************
 #Document Ready
**************************************************************************/

jQuery(document).ready(function() {
	appoly.contentNav();
});


/*************************************************************************
 #Document Load
**************************************************************************/

jQuery(window).on('load', function() {
	appoly.offCanvasNavigation();
	appoly.faqsAccordion();
	appoly.fixedNavigation();
	appoly.OpenContactLightbox();
});

jQuery(document).ready(function(){
	// Function to handle the parallax effect
	function parallaxScroll(initialLoad = false){
		// If mobile, ignore
		if (jQuery(window).width() < 768) {
			return;
		}

		jQuery('.parallax-section').each(function(){
			let scrollTop = jQuery(window).scrollTop();  // Get the current scroll position
			let sectionOffset = jQuery(this).offset().top;  // Get the offset of the current section
			let windowHeight = jQuery(window).height();  // Get the height of the window
			let documentHeight = jQuery(document).height(); // Get the total height of the document
			let sectionHeight = jQuery(this).outerHeight(); // Get the height of the section

			// Calculate the distance from the middle of the window to the section
			let distance = scrollTop + (windowHeight / 2) - (sectionOffset + (sectionHeight / 2));

			// Adjust for sections close to the top or bottom of the document
			let maxScrollableDistance = Math.max(sectionOffset, documentHeight - sectionOffset - sectionHeight);
			let normalizedDistance = distance * Math.min(1, windowHeight / (2 * maxScrollableDistance));

			let transition = initialLoad ? 'none' : 'transform 1s cubic-bezier(0.230, 1.000, 0.320, 1.000)';

			// Adjust each image's position based on its class with the appropriate transition
			jQuery(this).find('.blue-planet-medium').css({
				'transform': 'translateY(' + Math.max(Math.min(normalizedDistance * 0.3, 300), -300) + 'px)',
				'transition': transition
			});
			jQuery(this).find('.green-planet-medium').css({
				'transform': 'translateY(' + Math.max(Math.min(normalizedDistance * 0.6, 300), -300) + 'px)',
				'transition': transition
			});
			jQuery(this).find('.pink-planet-small').css({
				'transform': 'translateY(' + Math.max(Math.min(normalizedDistance * 1.3, 300), -600) + 'px)',
				'transition': transition
			});
		});
	}

	// Trigger the function on page load without animation
	parallaxScroll(true);

	// Bind the function to the scroll event with animation
	jQuery(window).on('scroll', function(){
		parallaxScroll();
	});
});

